import React, { useEffect, useState, useCallback } from 'react'
import s from './riskcarousel.module.css'
import Btn from '../buttons/buttons'
import Maratonista from '../../images/maratonista.svg'
import Piloto from '../../images/piloto.svg'
import Ciclista from '../../images/ciclista.svg'
import Senderista from '../../images/senderista.svg'
import { withPrefix } from 'gatsby';


const RiskCarousel = props => {
  const { testResult, handleButtonClick, handleRetakeTest } = props
  const [slides, setSlides] = useState([
    {
      title: 'Senderista',
      description: 'Fondo 0: Fondo de seguridad',
      body: `Tu posible rentabilidad no tiene muchas variaciones y mantienes tu fondo en el nivel de riesgo más bajo. Puedes elegir este fondo desde los 60 años de edad.`,
      image: Senderista,
      evaluationValue: 7, // 0 a 7
    },
    {
      title: 'Maratonista',
      description: 'Fondo 1: Conservador',
      body: `Vas por calles conocidas en un trote estable de largo aliento. Tienes una visión conservadora aunque el retorno de tu inversión sea bajo.`,
      image: Maratonista,
      evaluationValue: 11, // 8 a 11
    },
    {
      title: 'Ciclista',
      description: 'Fondo 2: Moderado',
      body: `Eres precavido y vas atento al camino. Quieres que tu capital crezca sin prisa pero sin pausa con un retorno medio-bajo.`,
      image: Ciclista,
      evaluationValue: 16, // 12 a 16
    },
    {
      title: 'Piloto de fórmula 1',
      description: 'Fondo 3: Crecimiento',
      body: `No existe el miedo cuando estás en la pista. Sabes que el riesgo es alto pero vas con confianza 
             por un gran crecimiento de tu capital y el retorno de tu inversión.`,
      image: Piloto,
      evaluationValue: 21, // 17 a 21
    },
  ])

  const findIndexOfSlide = () => {
    const slideIndex = slides.findIndex(slide => {
      return (
        (testResult <= 7 && slide.evaluationValue === 7) || // SLIDE 0 (0 a 7)
        (testResult >= 8 && testResult <= 11 && slide.evaluationValue === 11) || // SLIDE 1 (8 a 11)
        (testResult >= 12 && testResult <= 16 && slide.evaluationValue === 16) || // SLIDE 2 (12 a 16)
        (testResult >= 17 && slide.evaluationValue === 21) // SLIDE 3 (17 - 21)
      )
    })
    return slideIndex
  }

  useEffect(() => {
    setSlides(prev => {
      const initSlideIndex = findIndexOfSlide()
      const element = prev.splice(initSlideIndex, 1)[0]
      prev.unshift(element)
      return [...prev]
    })
  }, [])

  const [current, setCurrent] = useState(0)

  const goToSlide = useCallback(
    index => {
      let newIndex = index

      if (index < 0) {
        newIndex = slides.length - 1
      } else if (index >= slides.length) {
        newIndex = 0
      }

      setCurrent(newIndex)
    },
    [slides.length]
  )

  const prevSlide = current - 1 < 0 ? slides.length - 1 : current - 1
  const nextSlide = current + 1 > slides.length - 1 ? 0 : current + 1

  const methodButton = e => {
    e.preventDefault()
    handleButtonClick()
  }

  return (
    <div style={{ paddingTop: '1.21rem' }}>
      <div className={`center`}>
        <div className={`${s.carousel}`}>
          <div className={`${s.carouselSlides}`}>
            {slides.map((data, index) => (
              <div
                className={`${s.carouselSlide} ${
                  current === index ? s.isActive : ''
                } ${index === prevSlide ? s.isLeft : ''} ${
                  index === nextSlide ? s.isRight : ''
                }`}
                key={data.title}
                onClick={() =>
                  index !== current &&
                  (index === prevSlide
                    ? goToSlide(current - 1)
                    : goToSlide(current + 1))
                }
              >
                <div>
                  <div>
                    <span
                      className={`${s.carouselText} font-family-primary db tw-mb-4 ${current !== index &&
                        s.hideInfo}`}
                    >
                      Tu perfil de riesgo es:
                    </span>
                    <div
                      className={`${s.opacityInfo} ${
                        index === prevSlide ? s.isLeft : ''
                      } ${index === nextSlide ? s.isRight : ''}`}
                    >
                      <img src={data.image} alt='' className={`tw-mb-3`} />
                      <div className={`${s.carouselTitle} font-family-secondary tw-mt-0 tw-mb-3`}>{data.title}</div>
                      <div className={`font-family-primary fw-4 tw-f-18 tw-f-18@lg`}>
                        {data.description}
                      </div>
                    </div>
                  </div>
                  <div className={`${s.carouselText} font-family-primary pt-3 tw-px-4 tw-px-16@lg ${current !== index && s.hideInfo}`}>
                    {data.body}
                  </div>
                  <div
                    className={`${
                      current !== index ? s.hideInfo : s.riskContainerFooter
                    }`}
                  >
                    <button onClick={() => handleRetakeTest()}>
                      {' '}
                      <div className='items-center inline-flex pr-3'>
                        {' '}
                        <img
                          src={withPrefix('/images/prima-productos/black_arrow_right.svg')}
                          alt=''
                        />{' '}
                        <span className='pl-2 c-gray--4'>Rehacer test </span>{' '}
                      </div>
                    </button>
                    <Btn
                      className={`font-family-secondary`}
                      type={'button'}
                      label='Abrir cuenta'
                      color={'turquoise'}
                      onTouchStart={e => {
                        methodButton(e)
                      }}
                      onClick={e => {
                        methodButton(e)
                      }}
                      size='medium'
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default RiskCarousel
